import { render, staticRenderFns } from "./PassList.vue?vue&type=template&id=40d408d0"
import script from "./PassList.vue?vue&type=script&lang=js"
export * from "./PassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports